import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

export default class extends Controller {
  static targets = ["input", "results", "selectedId", "spinner"];
  static values = {
    selectedId: String,
  };

  connect() {
    StimulusReflex.register(this);
    console.log("AppellationFormSearchController connected");
  }

  search() {
    const query = this.inputTarget.value.trim();
    if (query.length < 2) {
      this.resultsTarget.classList.add("hidden");
      return;
    }

    // Set the query in the dataset for the reflex to access
    this.element.dataset.query = query;

    // Show spinner and results container
    this.showSpinner();
    this.resultsTarget.classList.remove("hidden");
    this.resultsTarget.classList.add("opacity-50");

    // Trigger the reflex
    this.stimulate("AppellationFormSearch#search");
  }

  // Reflex lifecycle methods
  beforeSearch() {
    this.resultsTarget.classList.add("opacity-50");
    this.showSpinner();
  }

  searchSuccess() {
    this.resultsTarget.classList.remove("opacity-50");
    this.hideSpinner();
  }

  searchError(error) {
    console.error("Search error:", error);
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.add("hidden");
    this.hideSpinner();
  }

  select(event) {
    const appellationId = event.currentTarget.dataset.appellationId;
    const appellationName = event.currentTarget.dataset.appellationName;

    this.selectedIdTarget.value = appellationId;
    this.inputTarget.value = appellationName;
    this.resultsTarget.classList.add("hidden");

    // Trigger change event for form validation
    this.inputTarget.dispatchEvent(new Event("change"));
    this.selectedIdTarget.dispatchEvent(new Event("change"));
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden");
    }
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden");
    }
  }

  // Called by the reflex after search
  receiveResults(html) {
    this.resultsTarget.innerHTML = html;
    this.resultsTarget.classList.remove("hidden");
  }
}
